import {AppAction} from '../../../../appActions';
import {ContactsManagerAccountDetailsActionsEnum} from './contactsManagerAccountDetailsActions';
import {AccountDetailsState} from './contactsManagerAccountDetailsState';

export function contactsManagerAccountDetailsReducer(
  state: AccountDetailsState,
  action: AppAction,
): AccountDetailsState | undefined {
  switch (action.type) {
    case ContactsManagerAccountDetailsActionsEnum.CLOSE_PANEL: {
      return undefined;
    }

    default: {
      return state;
    }
  }
}
